export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13196.15dd9ded.jpg";